import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CustomModalService, MIME_TYPES } from '@piqet-angular/shared';
import { ICellRendererParams } from 'ag-grid-community';
import { PdfService } from 'libs/data/src/lib/services/pdf-service/pdf.service';
@Component({
  selector: 'piqet-angular-verification-button-renderer',
  templateUrl: './verification-button-renderer.component.html',
  styleUrls: ['./verification-button-renderer.component.css'],
})
export class VerificationButtonRendererComponent implements OnChanges {
  params: any;
  @Input() docPath!: string;
  constructor(
    private modal: CustomModalService,
    private http: HttpClient,
    private pdfService: PdfService
  ) {}
  async agInit(params: ICellRendererParams<any, any>): Promise<void> {
    this.params = params;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.docPath = changes['docPath']?.currentValue;
  }

  pdfViewer() {
    const docPath = this.getDocPath();
    this.pdfService.openPdfInModal(this.modal, docPath);
  }

  pdfDownload() {
    const docPath = this.getDocPath();
    this.pdfService.downloadPdf(docPath).subscribe({
      next: (blob: Blob) => {
        if (blob.type === MIME_TYPES.APPLICATION_JSON) {
          return;
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = docPath.split('/').pop() ?? 'download.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: error => {},
    });
  }

  pdfOpenInNewTab() {
    const docPath = this.getDocPath();
    this.pdfService.openPdfInNewTab(docPath);
  }

  getDocPath(): string {
    return this.params?.data?.docPath ?? this.docPath;
  }
}
